<template>
<div class="page page_baocuo">
    <div class="filed">
        <div class="filed_title">评论</div>
        <div class="filed_nr">
            <van-field v-model="comment" type="textarea" placeholder="请您输入...." />
        </div>
    </div>
    <div class="filed">
        <div class="filed_title">图片</div>
        <div class="filed_nr">
            <!-- <van-field v-model="describe" type="textarea" placeholder="请您输入正确内容..."  /> -->
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <!-- <img class="image" :src="item" /> -->
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
    </div>
    <div class="actions">
        <div class="bottom_action" @click="tijiaoFun">提交评论</div>
    </div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";

import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage, 
            location_id: this.$route.query.location_id,
            comment: '', // 地址 比如错误信息在第几行
            imglist: [], // 上传回显图片列表
            url: 'http://timemap2.shanmuzhi.com',
            token:''
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '评论'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
        // 提交
        tijiaoFun() {
            if (!this.comment) {
                this.$toast('评论不能为空');
                return
            }
            var params = {
                token: this.token,
                location_id: this.location_id,
                comment: this.comment,
                parentid: 0 //上级评论ID，没有添0
            }
            if (this.imglist.length > 0) {
                params.attr = this.imglist
            }
            console.log(params)
            this.$api.map.createComment(params).then(res => {
                if (res.code == 200) {
                    // console.log('提交成功')
                    // console.log(res)
                    this.$toast('提交成功')
                    this.$router.back(-1);
                }
            })
        },
        // 图片上传
        onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
